import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/kasyap.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaDiscord, FaEnvelope, FaLinkedinIn, FaMailBulk, FaMailchimp } from "react-icons/fa";
import ContactForm from "./ContactForm";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I fell in love with programming, and I've been on a continuous journey of learning and growth ever since.
              <br />
              <br />I am fluent in a range of programming languages including
              <i>
                <b className="purple">  C, Python, Java, and JavaScript. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Full Stack Websites </b> and
                also in areas <br/>related to{" "}
                <b className="purple">
                Artificial Intelligence and Machine learning.
                </b>
              </i>
              <br />
              <br />
              I apply my passion for developing products with frameworks like 
              <b className="purple"> Spring Boot, Flask</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js, Angular  and Node.js</b>
              </i>
              <br/>
              <br/>
              I Worked With Both Databases  

              <i>
                <b className="purple"> Mysql And Mongo DB</b>
              </i>

            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid myimg" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <ContactForm/>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons" title="My GitHub">
                <a
                  href="https://github.com/kasyap2807"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons" title="My Linkdin">
                <a
                  href="http://www.linkedin.com/in/krishnakasyap"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons" title="My Discard">
                <a
                  href="https://discordapp.com/users/1197968138927620159"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons" title="My Email">
                <a
                  href="https://mail.google.com/mail/u/0/?fs=1&to=kanuparthikasyap95@gmail.com&su=Subject&body=BodyText&tf=cm"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaEnvelope />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
